import React from "react";
import {useNavigate} from "react-router-dom";

const LoginModal = ({ show, onClose, message, redirectPath = '/login' }) => {
  const navigate = useNavigate();

  const handleOkClick = () => {
    onClose();
    navigate(redirectPath);
  };

  if (!show) return null;
  return (
    <div 
      className={`modal fade ${show ? "show d-block" : ""}`} 
      style={{ backgroundColor: "rgba(0,0,0,0.5)" }} 
      onClick={onClose}
    >
      <div 
        className="modal-dialog modal-dialog-centered"
        style={{ width:'25%'}}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-content text-center p-3 rounded shadow-sm">
          <p className="mb-4">{message}</p>  
          <div className="modal-footer justify-content-center border-0">
            <button 
              onClick={handleOkClick}
              className="btn btn-primary px-4 py-1 w-auto" 
            >
              OK
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginModal;
